/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MemorizeMode {
    MemorizeNothing = 'MemorizeNothing',
    MemorizeAll = 'MemorizeAll'
}

export function MemorizeModeFromJSON(json: any): MemorizeMode {
    return MemorizeModeFromJSONTyped(json, false);
}

export function MemorizeModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemorizeMode {
    return json as MemorizeMode;
}

export function MemorizeModeToJSON(value?: MemorizeMode | null): any {
    return value as any;
}

